<img [src]="imagePath"
     class="round-image"
     (error)="changeSource()"/>
     